<template>
  <div class="myaccount">
    <div class="breadcrumb" style="background: #fff">修改密码</div>
    <div class="order-detail-basic">
      <el-form :model="data" :rules="rules" label-width="100px" ref="formRef">
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model="data.phone"></el-input>
        </el-form-item>
        <el-form-item label="验证码:" prop="verification">
          <el-input v-model="data.code"></el-input>
          <el-button @click="forgetGetCode" auto-complete="new-password" :disabled='forgetBtn' round>{{forgettext}}</el-button>
        </el-form-item>
        <el-form-item label="新密码:" prop="newPass">
          <el-input v-model="data.password" auto-complete="new-password" show-password></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round @click="$router.go(-1)">返回</el-button>
      <el-button round type="primary" @click="submitForm">保存</el-button>
    </div>
  </div>
</template>
 <script>
import { resetPwd } from '@/api/user'
import { codeSms, userFindPwd } from '@/api/crm'
export default {
  name: 'myaccount',
  data () {
    return {
      forgetBtn: false,
      forgettext: '获取验证码',
      value: '1254',
      data: {
        code: '',
        password: '',
        phone: ''
      },
      rules: {
        phone: [
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    forgetGetCode () {
      this.$refs.formRef.validateField('phone', errorMessage => {
        ;
        if (errorMessage) return false
        codeSms(this.data.phone, 'FINDPWD').then(res => {
          ;
          if (res.data.success) {
            this.$message({
              message: '发送成功',
              type: 'success'
            })
            this.forgetBtn = true
            this.forgettext = '已发送 (' + 120 + 's)'
            let i = 119
            const forgetTimer = setInterval(() => {
              this.forgettext = '已发送 (' + i + 's)'
              i--
              if (i < 0) {
                this.forgetBtn = false
                this.forgettext = '获取验证码'
                clearInterval(forgetTimer)
              }
            }, 1000)
          } else {
            ;
            if (res.data.message === 'crm.phone.code.send.failed') {
              this.$message({
                message: '发送失败',
                type: 'error'
              })
            } else if (res.data.message === 'crm.phone.code.has.send') {
              this.$message({
                message: '已经发送验证码，请稍后',
                type: 'error'
              })
            }
          }
        })
      })
    },
    submitForm () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return
        }
        userFindPwd(this.data).then(res => {
          ;
          if (res.data.success) {
            this.$message.success('修改密码成功，请重新登录')
            localStorage.removeItem('userId')
            localStorage.removeItem('token')
            this.$router.push('/')
          }
        })
      })
    }
  }
}
</script>
 <style scoped lang="less">
@import "styles";
//@depp: ~>>>''
</style>
